import React, { ReactNode, useEffect } from "react";

//Redux
import { useDispatch, useSelector } from 'react-redux';
import { MenuState } from '../../store/reducers/menuReducer';
import { RootState } from '../../store/index';

import "./Layout.css";

import Menu from "./Menu/Index";
import { TopMenu } from "./TopMenu/Index";
import MobileMenu from './MobileMenu';

import { CircularProgress, Grid } from "@material-ui/core";
import { UserState } from "../../store/reducers/userReducer";
import { useState } from "react";
import { Period } from "../../models/Period";

interface Props {
    //MenuTop
    pageTitle?: string,
    header?: React.ReactNode,
    lastUpdate?: string
    runUpdate?: Function,
    periodSelection?: {
        periods: Period[],
        customPeriod: Period,
        customPeriodType: string,
        onChange: Function
    },
    selection?: {
        selections: Period[],
        onChange: Function
    },
    showTutorials?: boolean,
    footer?: ReactNode
    invisible?: boolean
    style?: React.CSSProperties
}

const Layout: React.FC<Props> = (props) => {
    const menu = useSelector<RootState, MenuState>(state => state.menu);
    const user = useSelector<RootState, UserState>(state => state.user);
    const withTabMenu = menu.selectedSubItem && menu.selectedSubItem.children.length > 0;
    const [loading, setLoading] = useState<boolean>(true);

    const dispatch = useDispatch();

    const [showTutorials, setShowTutorials] = useState<boolean>(false);

    const closeMenus = () => {
        window.innerWidth <= 600 && dispatch({ type: 'MENU_TOGGLE', payload: true });
        menu.showSubMenu && dispatch({ type: 'MENU_SUB_VISIBLE', payload: false });
        menu.showUserMenu && dispatch({ type: 'MENU_USER_VISIBLE', payload: false });
    }

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 3000);
    }, []);

    return (
        <>
            <Menu changeShowTutorials={() => setShowTutorials(!showTutorials)} />
            {
                user
                    ? <main>
                        <div style={{ display: !props.invisible ? 'block' : 'none' }}>
                            <MobileMenu
                                pageTitle={props.pageTitle}
                                topMenuUpdate={props.lastUpdate}
                                topMenuSelection={props.selection}
                                topMenuTutorials={showTutorials}
                            />
                            {
                                window.screen.width > 600 &&
                                <TopMenu
                                    pageTitle={props.pageTitle}
                                    header={props.header}
                                    lastUpdate={props.lastUpdate}
                                    selection={props.selection}
                                    showTutorials={showTutorials} />

                            }
                        </div>
                        <div
                            className={`page ${withTabMenu ? 'withtabmenu' : ''}`}
                            style={props.style && props.style}
                            onClick={() => closeMenus()}
                            onMouseEnter={() => closeMenus()}>
                            {props.children}
                        </div>
                        <Grid container justifyContent="center" >
                            {props.footer}
                        </Grid>
                    </main>
                    : <Grid container justifyContent="center" alignItems="center">
                        <CircularProgress />
                    </Grid>
            }
        </>
    )
}

export default Layout;